const NavMenuLangSelector = {

  _isExpanded: false,

  _selectors: {
    sidebarFooter: '.js-nav-sidebar-footer',
    container: '.js-lang-select',
    currentLangBtn: '.js-lang-select-btn'
  },

  init() {
    document
      .querySelector(this._selectors.sidebarFooter)
      .querySelector(this._selectors.currentLangBtn)
      .addEventListener('click', this.handleClick.bind(this))
    ;
  },

  handleClick() {
    if (this._isExpanded) {
      this.collapse();
    } else {
      this.expand();
    }
  },

  expand() {
    const self = this;

    document
      .querySelector(this._selectors.sidebarFooter)
      .classList.add('expand')
    ;

    // Adds timeout to avoid triggering collapse event
    setTimeout(() => {
      self._isExpanded = true;
    });
  },

  collapse() {
    document
      .querySelector(this._selectors.sidebarFooter)
      .classList.remove('expand')
    ;

    this._isExpanded = false;
  }
};

export default NavMenuLangSelector;